import { SmallText } from 'inpock-ui-react';

import * as S from './styled';

interface CalloutProps {
  text: string;
  className?: string;
}

export function Callout({ text, className }: CalloutProps) {
  return (
    <S.Container className={className}>
      <SmallText color="gray600">{text}</SmallText>
    </S.Container>
  );
}
